import { Injectable, Injector } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { AppSettings } from '@app/common/app-setting';
import { HTTP_INTERCEPTORS, HttpClient, HttpHeaders } from '@angular/common/http';
import { AutharizedEndPointService } from '@app/services/base-service/autharized-endpoint.service';
import { TransactionHistoryModel, CustomerSearchFilterModel } from '@app/models/customer-transaction-history/TransactionHistoryModel';
import { CustomerTxnReportSearch } from '../../models/customer-transaction-history/TransactionHistoryModel';
import { json } from '../../../../node_modules/@types/d3';
import { TransactionFilterModel, SearchFilterModel, FilterModel } from '@app/models/customer-transaction-history/Transaction-Filter-model';
import { MerchantProfileModel } from '@app/models/merchant-profile-model/merchant-profile-model';
import { CreditManagementModel, CreditManagementListModel, CreditPagingModel } from '@app/models/merchant/creditManagementModel';
import { DebugContext } from '@angular/core/src/view';
import { ServiceRequestModel, HelpDeskModel } from '@app/models/merchant-settlement-model/merchant-settlement-model';
import { TerminalSearchInfo } from '@app/models/terminal/TerminalSearchInfoModel';
import { AcquirerOutlet } from '@app/models/merchant/AcquirerModel';
import { Paymentdetails } from '@app/models/merchant/merchantPaymentIndividualTransactionsModel';
import { TicketManagementModel } from '@app/models/ticketManagement/TicketManagementModel';
import { filter } from 'rxjs/operator/filter';


@Injectable()
export class TransactionHistoryEndpoint extends AutharizedEndPointService {
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    _baseurlNew = `${AppSettings.API_MERCHANT_ENDPOINT}`;
    private readonly _getgetpatanajliTransactionHistoryUrl: string = 'api/CustomerReportManagement/GetMerchantTxnSummary';
    private readonly _getTransactionHistoryUrl: string = 'api/CustomerReportManagement/CustomerTransactionDetails';
    private readonly _getPrePaidCreditCardHistoryUrl: string = 'api/MerchantDashboardReport/GetCustomerPrePaidCreditCardDetail';
    private readonly _getUpdateCreditLimitUrl: string = 'api/MerchantDashboardReport/UpdateCreditLimit/';
    private readonly _getTransactionHistoryDashboardUrl: string = '/api/CustomerReportManagement/GetCustomerTransactionDetails/';
    private readonly _getMerchantDetailsUrl: string = 'api/MerchantDashboardReport/GetMerchantProfile';
    private readonly _getMerchantTerminalNumUrl: string = 'api/MerchantDashboardReport/GetMerchantTerminal';
    private readonly _getMerchantTerminalOutlet: string = 'api/MerchantDashboardReport/GetMerchantOutlet';
    private readonly _getAcquirerOutlet: string = 'api/MerchantDashboardReport/GetAllOutlet';
    private readonly _getIssuerType: string = 'api/MerchantDashboardReport/GetIssuerType';
    private readonly _getIssuerStatus: string = 'api/MerchantDashboardReport/GetIssuerStatus';
    private readonly _getTicketType: string = 'api/MerchantDashboardReport/GetTicketType';
    private readonly _getCountTicket: string = 'api/MerchantDashboardReport/getTicketCount';
    private readonly _getOpenTicketDetailsUrl: string = 'api/MerchantDashboardReport/GetOpenTicketDetails';
    private readonly _getCloseTicketDetailsUrl: string = 'api/MerchantDashboardReport/GetCloseTicketDetails';
    private readonly _getInProgressTicketDetailsUrl: string = 'api/MerchantDashboardReport/GetInProgressTicketDetails';
    private readonly _getIssuerDetailsDataUrl: string = 'api/MerchantDashboardReport/GetIssueDetailsData';
    private readonly _getIssuerGridDetailsDataUrl: string = 'api/MerchantDashboardReport/GetIssueGridDetailsData';
    private readonly _saveTicketMgmtDataUrl: string = 'api/MerchantDashboardReport/SaveTicketMgmtData'
    private readonly _getMerchantTxnSummaryUrl: string = 'api/MerchantDashboardReport/GetMerchantSettlementSummary';
    private readonly _getMerchantOutletwiseTxnUrl: string = 'api/MerchantDashboardReport/GetMerchantOutletwiseReport';
    private readonly _getMerchantSummaryUrl: string = 'api/MerchantDashboardReport/GetMerchantSummary';
    private readonly _getMerchantOutletwiseTxnPdfExcelUrl: string = 'api/MerchantDashboardReport/GetMerchantOutletwiseReportPdfExcel';
    private readonly _getTransactionHistoryReportPdfExcelUrl: string = '/api/CustomerReportManagement/CustomerTransactionReportPdfExcel/';
    private readonly _getOutletDetailsByIdUrl: string='api/MerchantDashboardReport/GetOutletDetailsById';
    private readonly _getTerminalDetailsByIdUrl: string='api/MerchantDashboardReport/GetTerminalDetailsById';
    private readonly _getAcquirerTerminalUrl: string='api/MerchantDashboardReport/GetTerminalList';
    private readonly _getCustomerListUrl: string='api/MerchantDashboardReport/GetCustomerCreditList';
    private readonly _getSearchCustomerUrl: string='api/MerchantDashboardReport/searchCustomer';
    private readonly _getUpdateCustomerLimitUrl: string='api/MerchantDashboardReport/updateCustomerLimit';
    private readonly _getMerchantTxnUrl: string='api/MerchantDashboardReport/MerchantTransactionTxn';
    private readonly _getMerchantTxnPdfExcelUrl: string='api/MerchantDashboardReport/MerchantTransactionTxnPdfExcel';
    private readonly _getMerchantTxnDetailsUrl:string='api/MerchantDashboardReport/MerchantTransaction'
    private readonly _getTxnStatusWiseCountDetailsUrl:string='api/MerchantDashboardReport/MerchantTxnStatusWiseCountDetails'
    private readonly _getMerchantSettlementDetailsUrl:string='api/MerchantDashboardReport/GetSettlement'
    private readonly _getIssuerDetailsUrl:string='api/MerchantDashboardReport/GetIssuerDetails'
    private readonly _getMerchantSettlementDetailsPdfExcelUrl: string = 'api/MerchantDashboardReport/GetSettlementPdfExcel'
    private readonly _getBillingSettlementUrl: string = 'api/MerchantDashboardReport/GetBillingSettlement'
    private readonly _getBillingRequestUrl: string = 'api/MerchantDashboardReport/GetBillingRequest'
    private readonly _postServiceRequestUrl: string = 'api/MerchantDashboardReport/PostServiceRequest'
    private readonly _postunsubscribeDashboardReporttUrl: string = 'api/MerchantDashboardReport/unsubscribeDashboardReport'
    private readonly _postsubscribeDashboardReporttUrl: string = 'api/MerchantDashboardReport/subscribeDashboardReport'
    private readonly _postsaveDashboardReporttUrl: string = 'api/MerchantDashboardReport/saveDashboardReport'
    private readonly _getIssueDetailsUrl: string = 'api/MerchantDashboardReport/GetServiceRequestDetails'
    private readonly _getIssueTypeUrl: string = 'api/MerchantDashboardReport/GetServiceRequestIssueType'
    private readonly _getMerchantHierarchyUrl: string = 'api/MerchantDashboardReport/GetMerchantHierarchy/';
    private readonly _getZonalMerchantDataUrl: string = 'api/MerchantDashboardReport/GetZonalMerchantData';
    private readonly _getRegionalMerchantDataUrl: string = 'api/MerchantDashboardReport/GetRegionalMerchantData/';
    private readonly _getLocationDataUrl: string = 'api/MerchantDashboardReport/GetLocationData/';
    private readonly _getMerchantPaymentDayWiseUrl: string = 'api/MerchantDashboardReport/GetPaymentDetailsDayWise';
    private readonly _getMerchantSettlementDateWiseUrl:string='api/MerchantDashboardReport/GetMerchantSummaryDateWise'
    private readonly _getMerchantSettlementIndividualUrl:string='api/MerchantDashboardReport/GetMerchantSummaryIndividual'
    private readonly _getRaiseTicketListUrl:string='api/MerchantDashboardReport/GetRaiseTicketList'
    private readonly _saveRaisedTicketDataUrl:string='api/MerchantDashboardReport/SaveRaisedTicketData'
    private readonly _getTerminalListOnMerchantIdUrl:string='api/MerchantDashboardReport/GetTerminalListOnMerchantId/'
    private readonly _getTerminalListOnMerchantIdUrlNew:string='v3/terminals/'
    private readonly _getTerminalByOutletCode:string='api/MerchantDashboardReport/GetTerminalByOutletCode/'
    private readonly _registerPostImageDataUrl: string = 'api/MerchantDashboardReport/UploadFile/';
    private readonly _getAccessTypeListUrl: string = 'api/MerchantDashboardReport/GetAccessTypeList';
    private readonly _getMerchantTxnDetailsSummaryUrl :string='api/MerchantDashboardReport/GetMerchantTxnDetailsSummary'
    private readonly _getMerchantTxnDetailsSummaryListUrl :string='api/MerchantDashboardReport/GetMerchantTxnSummary'
    private readonly _getDetailsForRaiseTicketUrl:string='api/MerchantDashboardReport/GetDetailsForRaiseTicket'
    // private readonly _getMerchantSettlementDetailsPdfExcelUrl:string='api/MerchantDashboardReport/GetSettlementPdfExcel'
    // private readonly _getBillingSettlementUrl:string='api/MerchantDashboardReport/GetBillingSettlement'
    // private readonly _getBillingRequestUrl:string='api/MerchantDashboardReport/GetBillingRequest'
    // private readonly _postServiceRequestUrl:string='api/MerchantDashboardReport/PostServiceRequest'
    // private readonly _getIssueDetailsUrl:string='api/MerchantDashboardReport/GetServiceRequestDetails'
    // private readonly _getIssueTypeUrl:string='api/MerchantDashboardReport/GetServiceRequestIssueType'
    // private readonly _getMerchantHierarchyUrl: string='api/MerchantDashboardReport/GetMerchantHierarchy/';
    // private readonly _getZonalMerchantDataUrl: string='api/MerchantDashboardReport/GetZonalMerchantData';
    // private readonly _getRegionalMerchantDataUrl: string='api/MerchantDashboardReport/GetRegionalMerchantData/';
    // private readonly _getLocationDataUrl: string='api/MerchantDashboardReport/GetLocationData/';
    
    constructor(http: HttpClient) {
        super(http, 'UserManagement/Roles');
        this.http1 = http;
    }
    getUrl(url: string) {
        return this._baseurl + url;
    }

    getUrlNew(url: string) {
        return this._baseurlNew + url;
    }
    getpatanajliTransactionHistory(data: CustomerTxnReportSearch) {
        return this.http1.post
            (this.getUrl(this._getgetpatanajliTransactionHistoryUrl), JSON.stringify(data), this.AddAuthToken());
    }
    getTransactionHistory(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getTransactionHistoryUrl), trans, this.AddAuthToken());
    }

    getMerchantTxn(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantTxnUrl), trans, this.AddAuthToken());
    }

    getMerchantTxnPdfExcel(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantTxnPdfExcelUrl), trans, this.AddAuthToken());
    }

    getTransactionReportPdfExcel(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getTransactionHistoryReportPdfExcelUrl), trans, this.AddAuthToken());
    }

    getPrePaidCreditCardHistory(data: CustomerSearchFilterModel) {
        return this.http1.get(this.getUrl(this._getPrePaidCreditCardHistoryUrl));
        // return this.http1.post(this.getUrl(this._getPrePaidCreditCardHistoryUrl), JSON.stringify(data),this.AddAuthToken());
    }

    updateData(customerId: number, LoadMoneyAmount: number, StatementPeriod: number) {
        return this.http1.get(this.getUrl(this._getUpdateCreditLimitUrl) + customerId + '/' + LoadMoneyAmount + '/' + StatementPeriod, this.AddAuthToken());
    }

    getTransactionHistoryDashboard(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getTransactionHistoryDashboardUrl), trans, this.AddAuthToken());
    }

    getMerchantDetails() {
        return this.http1.get
            (this.getUrl(this._getMerchantDetailsUrl), this.AddAuthToken());
    }

    getMerchantTerminalNum(outletId: MerchantProfileModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantTerminalNumUrl), outletId, this.AddAuthToken());
    }

    GetMerchantHierarchy(EntityValue: number) {
        return this.http1.get
            (this.getUrl(this._getMerchantHierarchyUrl) + EntityValue, this.AddAuthToken());
    }

    getMerchantOutlet(filtermodel: FilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantTerminalOutlet), filtermodel, this.AddAuthToken());
    }

    getMerchantTxnSummary(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantTxnSummaryUrl), trans, this.AddAuthToken());
    }

    getMerchantOutletTxn(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantOutletwiseTxnUrl), trans, this.AddAuthToken());
    }

    getMerchantOutletTxnPdfExcel(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantOutletwiseTxnPdfExcelUrl), trans, this.AddAuthToken());
    }

    getMerchantSummary(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantSummaryUrl), trans, this.AddAuthToken());
    }


    getAcquirerOutlet(outletInfo: AcquirerOutlet) {
        return this.http1.post
            (this.getUrl(this._getAcquirerOutlet), outletInfo, this.AddAuthToken());
    }

    getOutletDetailsById(OutletId: number) {
        return this.http1.post
            (this.getUrl(this._getOutletDetailsByIdUrl), OutletId, this.AddAuthToken());
    }

    getAcquirerTerminal(terminalInfo: TerminalSearchInfo) {
        return this.http1.post
            (this.getUrl(this._getAcquirerTerminalUrl), terminalInfo, this.AddAuthToken());
    }

    getTerminalDetailsById(OutletId: number) {
        return this.http1.post
            (this.getUrl(this._getTerminalDetailsByIdUrl), OutletId, this.AddAuthToken());
    }

    getCustomerList(customerCode: CreditPagingModel) {
        return this.http1.post
            (this.getUrl(this._getCustomerListUrl), customerCode, this.AddAuthToken());
    }

    searchCustomer(customerCode: CreditManagementModel) {
        return this.http1.post
            (this.getUrl(this._getSearchCustomerUrl), customerCode, this.AddAuthToken());
    }

    updateCustomerLimit(customerLimit: CreditManagementModel) {
        return this.http1.post
            (this.getUrl(this._getUpdateCustomerLimitUrl), customerLimit, this.AddAuthToken());
    }

    getTxnDetails(searchFilter: SearchFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantTxnDetailsUrl), searchFilter, this.AddAuthToken());
    }
    getTxnStatusWiseCountDetails(searchFilter: SearchFilterModel) {
        return this.http1.post
            (this.getUrl(this._getTxnStatusWiseCountDetailsUrl), searchFilter, this.AddAuthToken());
    }
    getSettlementDetails(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantSettlementDetailsUrl), trans, this.AddAuthToken());
    }

    showMerchantSummaryDatewise(trans: TransactionFilterModel) {
        // debugger
        return this.http1.post
            (this.getUrl(this._getMerchantSettlementDateWiseUrl),trans,this.AddAuthToken());
    }

    showMerchantSummaryIndividual(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantSettlementIndividualUrl),trans,this.AddAuthToken());
    }

    getSettlementDetailsPfdExcel(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getMerchantSettlementDetailsPdfExcelUrl), trans, this.AddAuthToken());
    }
    getBillingSettlement(trans: TransactionFilterModel) {
        return this.http1.post
            (this.getUrl(this._getBillingSettlementUrl), trans, this.AddAuthToken());
    }

    getBillingRequest(trans: TransactionFilterModel) {
        // debugger
        return this.http1.post
            (this.getUrl(this._getBillingRequestUrl), trans, this.AddAuthToken());
    }

    submitServiceRequest(serviceRequestModel: ServiceRequestModel) {
        return this.http1.post
            (this.getUrl(this._postServiceRequestUrl), serviceRequestModel, this.AddAuthToken());
    }

    getIssueType() {
        return this.http1.get
            (this.getUrl(this._getIssueTypeUrl), this.AddAuthToken());
    }

    getIssueDetails() {
        return this.http1.get
            (this.getUrl(this._getIssueDetailsUrl), this.AddAuthToken());
    }
    GetZonalMerchantData() {
        return this.http1.get
            (this.getUrl(this._getZonalMerchantDataUrl), this.AddAuthToken());
    }
    GetRegionalMerchantData(ParentMerchantId: number) {
        return this.http1.get
            (this.getUrl(this._getRegionalMerchantDataUrl) + ParentMerchantId, this.AddAuthToken());
    }
    getLocationData(LocationTypeId: number, ParentMerchantId: number) {
        return this.http1.get
            (this.getUrl(this._getLocationDataUrl) + LocationTypeId + '/' + ParentMerchantId, this.AddAuthToken());
    }

    getPaymentDetailsDayWise(paymentdetails: Paymentdetails) {
        // debugger
        return this.http1.post
            (this.getUrl(this._getMerchantPaymentDayWiseUrl), paymentdetails, this.AddAuthToken());
    }

    unsubscribeDashboardReport(value:string) {
        // debugger
        return this.http1.post
            (this.getUrl(this._postunsubscribeDashboardReporttUrl), JSON.stringify(value), this.AddAuthToken());
    }

    subscribeDashboardReport(value:string) {
        // debugger
        return this.http1.post
            (this.getUrl(this._postsubscribeDashboardReporttUrl), JSON.stringify(value), this.AddAuthToken());
    }
    saveDashboardReport(value:string) {
        // debugger
        return this.http1.post
            (this.getUrl(this._postsaveDashboardReporttUrl),  JSON.stringify(value), this.AddAuthToken());
    }
    getRaiseTicketList(ticketManagementModel:TicketManagementModel) {
        return this.http1.post
            (this.getUrl(this._getRaiseTicketListUrl),ticketManagementModel, this.AddAuthToken());
    }
    getDetailsForRaiseTicket(data:TicketManagementModel) {
        return this.http1.post
            (this.getUrl(this._getDetailsForRaiseTicketUrl),data, this.AddAuthToken());
    }
    GetTerminalListOnMerchantId(merchantId) {
        return this.http1.get
            (this.getUrl(this._getTerminalListOnMerchantIdUrl) +merchantId, this.AddAuthToken());
    }

    GetTerminalListOnMerchantIdNew(merchantId) {
        return this.http1.get
            (this.getUrlNew(this._getTerminalListOnMerchantIdUrlNew) +merchantId, this.AddAuthToken());
    }
    SaveRaisedTicketData(ticketManagementModel:TicketManagementModel) {
        return this.http1.post
            (this.getUrl(this._saveRaisedTicketDataUrl),ticketManagementModel, this.AddAuthToken());
    }
    getTerminalByOutletCode(outletId:number) {
        return this.http1.get
            (this.getUrl(this._getTerminalByOutletCode)+outletId, this.AddAuthToken());
    }

    getIssuerType() {
        return this.http1.get
            (this.getUrl(this._getIssuerType), this.AddAuthToken());
    }

    getIssuerStatus() {
        return this.http1.get
            (this.getUrl(this._getIssuerStatus), this.AddAuthToken());
    }

    getTicketType() {
        return this.http1.get
            (this.getUrl(this._getTicketType), this.AddAuthToken());
    }

    getIssuerDetails(trans: HelpDeskModel) {
        // debugger
        return this.http1.post
            (this.getUrl(this._getIssuerDetailsUrl), trans, this.AddAuthToken());
    }

    getTicketCount(data:HelpDeskModel) {
        return this.http1.post
            (this.getUrl(this._getCountTicket),data, this.AddAuthToken());
    }

    getOpenTicketDetails(trans: HelpDeskModel) {
        return this.http1.post
            (this.getUrl(this._getOpenTicketDetailsUrl), trans, this.AddAuthToken());
    }

    getCloseTicketDetails(trans: HelpDeskModel) {
        return this.http1.post
            (this.getUrl(this._getCloseTicketDetailsUrl), trans, this.AddAuthToken());
    }

    getInProgressTicketDetails(trans: HelpDeskModel) {
        return this.http1.post
            (this.getUrl(this._getInProgressTicketDetailsUrl), trans, this.AddAuthToken());
    }

    getIssuerDetailData(trans: HelpDeskModel) {
        return this.http1.post
            (this.getUrl(this._getIssuerDetailsDataUrl), trans, this.AddAuthToken());
    }

    getIssuerGridDetailData(trans: HelpDeskModel) {
        return this.http1.post
            (this.getUrl(this._getIssuerGridDetailsDataUrl), trans, this.AddAuthToken());
    }

    saveTicketMgmtData(trans: HelpDeskModel) {
        return this.http1.post
            (this.getUrl(this._saveTicketMgmtDataUrl), trans, this.AddAuthToken());
    }
    fileUpload(formData: FormData,id:number) {
        return this.http1.post(this.getUrl(this._registerPostImageDataUrl)+id, formData );
    }
    getAccessTypeList(){
        return this.http1.get(this.getUrl(this._getAccessTypeListUrl), this.AddAuthToken());
    }

    getMerchantTxnDetailsSummary(searchFilter: CustomerTxnReportSearch) {
        return this.http1.post
            (this.getUrl(this._getMerchantTxnDetailsSummaryUrl), searchFilter, this.AddAuthToken());
    }

    getMerchantTxnSummaryList(searchFilterData: CustomerTxnReportSearch)
    {
        return this.http1.post
            (this.getUrl(this._getMerchantTxnDetailsSummaryListUrl), searchFilterData, this.AddAuthToken());
    }
}


// WEBPACK FOOTER //
// ./src/app/services/transactionHistory/transactionHistory-endpoint.service.ts